import { createBrowserRouter, Navigate } from "react-router";
import { LoginPage } from "./components/LoginPage";
import { LoginPageAlt } from "./components/LoginPageAlt";
import { LoginPageFigma } from "./components/LoginPageFigma";
import { OTPVerificationPage } from "./components/OTPVerificationPage";
import { AccountSelectionPage } from "./components/AccountSelectionPage";
import { MobileLoginPage } from "./components/MobileLoginPage";
import { MobileOTPVerificationPage } from "./components/MobileOTPVerificationPage";
import { MobileAccountSelectionPage } from "./components/MobileAccountSelectionPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/login",
    Component: LoginPageFigma,
  },
  // {
  //   path: "/login/alt",
  //   Component: LoginPageAlt,
  // },
  // {
  //   path: "/login/variant",
  //   Component: LoginPage,
  // },
  // {
  //   path: "/login/mobile",
  //   Component: MobileLoginPage,
  // },
  {
    path: "/login/*",
    element: <Navigate to="/login" replace />,
  },
]);